import React from "react";

export const Newsletter = () => {
  return (
    <div className="justify-center items-center h-200 md:hidden">
      <video 
        src="/Images/video1.mp4"  // Make sure this path is correct
        autoPlay
        muted
        loop
        playsInline
        className="w-full max-w-lg rounded-lg shadow-lg"
      />
    </div>
  );
};


